import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1db50d66")

_pushScopeId("data-v-1db50d66")
const _hoisted_1 = {
  key: 0,
  class: "kn-remove-card-padding p-col"
}
const _hoisted_2 = { class: "kn-list-item" }
const _hoisted_3 = { class: "kn-list-item-text" }
const _hoisted_4 = { class: "kn-truncated" }
const _hoisted_5 = {
  id: "form-container",
  class: "p-m-1"
}
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid p-mx-2 p-mt-5" }
const _hoisted_7 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_8 = { class: "p-float-label " }
const _hoisted_9 = {
  for: "driver",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_11 = { class: "p-float-label " }
const _hoisted_12 = {
  for: "filterOp",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_14 = { class: "p-float-label " }
const _hoisted_15 = {
  for: "logicalOp",
  class: "kn-material-input-label"
}
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-col-12 p-m-0" }
const _hoisted_18 = { class: "mode-inputs p-col-8" }
const _hoisted_19 = { class: "kn-material-input-label" }
const _hoisted_20 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (!_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.conditionsTitle')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('managers.businessModelManager.addCondition'),
              class: "p-button-text p-button-rounded p-button-plain kn-white-color",
              onClick: _ctx.showForm
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Listbox, {
          class: "kn-list data-condition-list",
          options: _ctx.conditions,
          onChange: _ctx.showForm
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.noDataCond')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("span", _hoisted_4, [
                  _createVNode("b", null, _toDisplayString(slotProps.option.filterOperation) + " " + _toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.dataConditionsValue')), 1),
                  _createTextVNode(" " + _toDisplayString(slotProps.option.parFatherUrlName), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    slotProps.option.filterOperation + _ctx.$t('documentExecution.documentDetails.drivers.dataConditionsValue') + slotProps.option.parFatherUrlName,
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _createVNode(_component_Button, {
                icon: "far fa-trash-alt",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _withModifiers(($event: any) => (_ctx.deleteConditions(slotProps.option)), ["stop"])
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["options", "onChange"]),
        _createVNode(_component_Dialog, {
          class: "remove-padding",
          style: _ctx.driversDescriptor.style.conditionDialog,
          visible: _ctx.conditionFormVisible,
          modal: true,
          closable: false
        }, {
          header: _withId(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
              start: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.visualizationTitle')), 1)
              ]),
              _: 1
            })
          ]),
          footer: _withId(() => [
            _createVNode(_component_Button, {
              class: "p-button-text kn-button",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.conditionFormVisible = false))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              class: "kn-button kn-button--primary",
              label: _ctx.$t('common.save'),
              onClick: _ctx.handleSubmit
            }, null, 8, ["label", "onClick"])
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", null, [
                _createVNode(_component_InlineMessage, {
                  severity: "info",
                  class: "kn-width-full"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.dataHint')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("form", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_Dropdown, {
                      id: "driver",
                      class: "kn-material-input",
                      modelValue: _ctx.condition.parFatherId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.condition.parFatherId = $event)),
                      options: _ctx.excludeCurrentDriverFromList(),
                      optionLabel: "label",
                      optionValue: "id",
                      onChange: _ctx.setParFatherUrlName
                    }, null, 8, ["modelValue", "options", "onChange"]),
                    _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.ad')) + " " + _toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.adDepends')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode(_component_Dropdown, {
                      id: "filterOp",
                      class: "kn-material-input",
                      modelValue: _ctx.condition.filterOperation,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.condition.filterOperation = $event)),
                      options: _ctx.availableOperators
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.businessModelManager.filterOperator')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", _hoisted_14, [
                    _createVNode(_component_Dropdown, {
                      id: "logicalOp",
                      class: "kn-material-input",
                      modelValue: _ctx.condition.logicOperator,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.condition.logicOperator = $event)),
                      options: _ctx.connectingOperators
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.businessModelManager.logicOperator')), 1)
                  ])
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
                  return (_openBlock(), _createBlock("div", {
                    key: mode.useID,
                    class: "p-col-12 p-mb-4"
                  }, [
                    _createVNode("form", _hoisted_16, [
                      _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('managers.businessModelManager.modality') + ': ' + mode.name), 1),
                      _createVNode("div", {
                        class: "mode-inputs p-col-4",
                        style: _ctx.driversDescriptor.style.modalityCheckbox
                      }, [
                        _createVNode(_component_Checkbox, {
                          class: "p-mr-2",
                          value: mode.useID,
                          modelValue: _ctx.selectedModes,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedModes = $event)),
                          disabled: _ctx.readonly
                        }, null, 8, ["value", "modelValue", "disabled"]),
                        _createVNode("label", null, _toDisplayString(_ctx.$t('managers.businessModelManager.check')), 1)
                      ], 4),
                      _createVNode("div", _hoisted_18, [
                        _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('managers.businessModelManager.lovsColumn')), 1),
                        _createVNode(_component_Dropdown, {
                          id: "parFather",
                          class: "kn-material-input",
                          modelValue: _ctx.modalities[mode.useID],
                          "onUpdate:modelValue": ($event: any) => (_ctx.modalities[mode.useID] = $event),
                          options: _ctx.getLovs(mode.idLov),
                          placeholder: _ctx.$t('managers.businessModelManager.lovsColumnSelect')
                        }, {
                          value: _withId((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                  _createVNode("span", null, _toDisplayString(slotProps.value), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          option: _withId((slotProps) => [
                            _createVNode("div", null, [
                              _createVNode("span", null, _toDisplayString(slotProps.option), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["style", "visible"])
      ]))
    : _createCommentVNode("", true)
})